import { useTranslation } from 'react-i18next';

interface OrderableTextProps {
  backgroundColor: string;
  orderableText: string;
}

/**
 * The OrderableText component renders a text with a colored dot.
 * @param backgroundColor - The background color of the dot.
 * @param orderableText - The text to render.
 * @returns The OrderableText component is returning JSX elements.
 */

const OrderableText = ({ backgroundColor, orderableText }: OrderableTextProps) => {
  return (
    <>
      <div className={`min-[350px]:w-[7px] min-[350px]:h-[7px] sm:w-[8px] sm:h-[8px] rounded-full  min-[350px]:mr-[6px]  sm:mr-[8px]`} style={{ backgroundColor: backgroundColor }} />
      <p className='min-[350px]:text-[14px] md:text-[16px] font-body font-medium text-black'>{orderableText}</p>
    </>
  );
};

/**
 * The AvailableText component renders a text with a green dot.
 * @returns The AvailableText component is returning JSX elements.
 */

export const AvailableText = () => {
  const { t } = useTranslation();
  return <OrderableText backgroundColor='#3DBA61' orderableText={t('winePackageWidget.orderable')} />;
};

/**
 * The NotAvailableText component renders a text with a red dot.
 * @returns The NotAvailableText component is returning JSX elements.
 */

export const NotAvailableText = () => {
  const { t } = useTranslation();
  return <OrderableText backgroundColor='#fa4d55' orderableText={t('winePackageWidget.notOrderable')} />;
};
